module.exports = __webpack_public_path__ + "static/media/prompt.f26b6100.png";